const initCountdowns = () => {
  const countdowns = document.querySelectorAll('[data-urgency-countdown]');

  countdowns.forEach((countdown) => {
    const timeElement = countdown.querySelector('.announcement-bar__urgency-countdown-time');
    if (!timeElement) return;

    const raw = (countdown.dataset.endTime || '').trim();
    if (!raw) return;

    const [endHours = '0', endMinutes = '0'] = raw.split(':');
    const targetHours = Number.parseInt(endHours, 10);
    const targetMinutes = Number.parseInt(endMinutes, 10);
    if (Number.isNaN(targetHours) || Number.isNaN(targetMinutes)) return;

    const containerAside = countdown.closest('.announcement-bar');
    const isCart = containerAside && containerAside.getAttribute('data-is-cart') === 'true';

    const now = new Date();
    const target = new Date(now);
    target.setSeconds(0, 0);
    target.setHours(targetHours, targetMinutes);

    if (target <= now) {
      target.setDate(target.getDate() + 1);
    }

    const format = (value) => value.toString().padStart(2, '0');

    const onExpire = () => {
      if (isCart) {
        window.location.reload();
        return;
      }

      const urgencyEl = countdown.closest('[data-urgency-container]');
      if (urgencyEl) urgencyEl.remove();

      const regular = containerAside && containerAside.querySelector('[data-regular-container]');
      if (regular) {
        regular.removeAttribute('hidden');
        if (regular.style && regular.style.display === 'none') {
          regular.style.display = '';
        }
      }
    };

    const update = () => {
      const diff = target.getTime() - Date.now();
      if (diff <= 0) {
        timeElement.textContent = '00h 00m 00s';
        onExpire();
        return;
      }

      const totalSeconds = Math.floor(diff / 1000);
      const hours = Math.floor(totalSeconds / 3600);
      const minutes = Math.floor((totalSeconds % 3600) / 60);
      const seconds = totalSeconds % 60;

      timeElement.textContent = `${format(hours)}h ${format(minutes)}m ${format(seconds)}s`;
    };

    update();
    const timer = setInterval(() => {
      update();
      if (target.getTime() - Date.now() <= 0) {
        clearInterval(timer);
      }
    }, 1000);
  });
};

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initCountdowns);
} else {
  initCountdowns();
}
